export class ConnectRestoreAccountResponse {
    'restoreAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
